import { render } from "./FooterLayer.vue?vue&type=template&id=6601eafd&scoped=true"
import script from "./FooterLayer.vue?vue&type=script&lang=js"
export * from "./FooterLayer.vue?vue&type=script&lang=js"

import "./FooterLayer.vue?vue&type=style&index=0&id=6601eafd&lang=less&scoped=true"

import exportComponent from "F:\\work\\projects\\HiOmics\\Front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6601eafd"]])

export default __exports__